import { useRecoilValue } from 'recoil';
import { formTemplateState, layoutSelector } from 'state';
import AddFieldButton from './FieldTemplate/AddFieldButton';
import { DropArea } from './FieldTemplate/DropArea';
import FieldTemplateRenderer from './FieldTemplate/FieldTemplateRenderer';
import { FormTemplateStatus } from 'api/models/FormTemplate';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { FormTemplateEditorMode } from '../FormTemplateEditor';

interface FormEditorProps {
  mode: FormTemplateEditorMode;
  isViewOnly?: boolean;
}

export default function FormEditor({ mode, isViewOnly }: FormEditorProps) {
  const layout = useRecoilValue(layoutSelector);
  const formTemplate = useRecoilValue(formTemplateState);
  const isEditDisabled =
    formTemplate?.status === FormTemplateStatus.Published || isViewOnly;

  return (
    <DndProvider backend={HTML5Backend}>
      <DropArea index={0} parentPath="children" />
      {layout.children.map((layoutItem, index) => {
        return (
          <FieldTemplateRenderer
            key={`${layoutItem.id}-layout-item-renderer-${index}`}
            index={index}
            parentPath="children"
            layoutItem={layoutItem}
            disabled={isEditDisabled}
            mode={mode}
          />
        );
      })}
      {layout.children.length === 0 && (
        <AddFieldButton
          disabled={isEditDisabled}
          parentPath="children"
          insertIndex={0}
        />
      )}
    </DndProvider>
  );
}
